// @ts-nocheck
import React from "react";
import styled from "styled-components";
import { Input as BaseAntdInput } from "antd";
import { ThemeColors } from "../../../utils/theme";

export interface TextInputProps {
  size: "small" | "middle" | "large";
  borderColor?: ThemeColors;
  background?: ThemeColors;
  borderRadius?: any;
  shouldShowError?: boolean;
  onChange?: any;
  onKeyPress?: any;
  value?: any;
  placeholder?: string;
  suffix?: any;
  readOnly?: boolean;
  style?: any;
  prefix?: any;
  type?: any;
}

const AntdInput: React.FC<TextInputProps> = props => {
  const {
    size,
    borderColor,
    background,
    borderRadius,
    shouldShowError,
    type,
    ...rest
  } = props;

  return type === 'password' ?
    <BaseAntdInput.Password {...rest} />
    :
    <BaseAntdInput {...rest} />
};

const StyledInput = styled(AntdInput)<TextInputProps>`
  && {
    height: ${props =>
      props.theme.components.inputs.height[props.size]}px !important;
    font-size: ${props => props.theme.components.inputs.fontSize[props.size]}px;
    border-color: ${props =>
      props?.borderColor
        ? props.theme.colors[props.borderColor]
        : props.theme.colors["grey5"]} !important;
    box-sizing: border-box;
    background-color: ${props =>
      props.background && props.theme.colors[props.background]} !important;
    border-radius: ${props => props.borderRadius}px !important;
  }
`;

export default StyledInput;
